module.exports = __webpack_public_path__ + "static/calendar-setting-41346e30da4bf9ab41667c40380a9eba.png";